module.exports = __webpack_public_path__ + "img/prop-sign-1-right.2ae5ba19.png";